import { useFormik } from "formik";
import PropTypes from "prop-types";
import React from "react";
import { withTranslation } from "react-i18next";
import { useHistory, useLocation, withRouter } from "react-router";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Card, CardBody, Col, Container, Form, FormFeedback, Input, Row } from "reactstrap";
import { Organisation } from "src/sdk/models/Organisation";
import { SuperAdminService } from "src/services/SuperAdminService";
import * as Yup from "yup";

const service = new SuperAdminService();
export const EditUsersManagment = () => {
    const location = useLocation();
    const history = useHistory();

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            userId: location.state.users.userId,
            firstName: location.state.users.firstName,
            lastName: location.state.users.lastName,
        },
        validationSchema: Yup.object({
            firstName: Yup.string()
                .required("Please enter first name"),
            lastName: Yup.string()
                .required("Please enter last name"),
        }),
        onSubmit: (values: any) => {
            console.log(values);
            service.editUser(values)
                .then(function (response) {
                    console.log(response);
                    history.push({
                        pathname: "/users-managment",
                        state: location.state.organisation as Organisation
                    });
                    toast.success("Successfully saved!");
                })
                .catch(function (error) {
                    console.log("API ERROR");
                    console.log(error);
                });
        }
    });

    return (
        <React.Fragment>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div style={{ paddingTop: 10, paddingBottom: 20, display: "flex", flexDirection: "row" }}>
                            <Link style={{ color: "black" }}
                                to="/organisations"
                                className="nav_link"
                            >
                                <h5>Organizations</h5>
                            </Link>
                            <i className="bi bi-chevron-right"></i>
                            <Link style={{ color: "black", marginLeft: 10 }}
                                to={{
                                    pathname: '/users-managment',
                                    state: location.state.organisations
                                }}
                                className="nav_link"
                            >
                                <h5>{location.state.organisation.name}</h5>
                            </Link>
                            <i className="bi bi-chevron-right"></i>
                            <h5 style={{ marginRight: 13, marginLeft: 13 }}>{location.state.users.firstName} {location.state.users.lastName}</h5>
                            <i className="bi bi-chevron-right"></i>
                            <h5 style={{ marginLeft: 13, opacity: 0.6 }}>Edit User</h5>
                        </div>
                    </div>
                </div>
                <Row>
                    <Col xl={12}>
                        <Card style={{ border: 0 }}>
                            <CardBody >
                                <div className="row">
                                    <div className="col-10">
                                        <Row>
                                            <Col sm="12">
                                                <Form
                                                    onSubmit={(e) => {
                                                        e.preventDefault();
                                                        validation.handleSubmit();
                                                        return false;
                                                    }}
                                                >
                                                    <Container fluid>
                                                        <Row >
                                                            <Col lg={4} md={5} className="col-xxl-2 p-2">
                                                                <h5>First name:</h5>
                                                            </Col>
                                                            <Col lg={4} md={5} className="col-xxl-10">
                                                                <Input
                                                                    id="firstName"
                                                                    name="firstName"
                                                                    className="form-control"
                                                                    placeholder="Enter first name"
                                                                    type="text"
                                                                    onChange={validation.handleChange}
                                                                    onBlur={validation.handleBlur}
                                                                    value={validation.values.firstName || ""}
                                                                    invalid={
                                                                        validation.touched.firstName && validation.errors.firstName ? true : false
                                                                    }
                                                                />
                                                                {validation.touched.firstName && validation.errors.firstName ? (
                                                                    <FormFeedback type="invalid"><>{validation.errors.firstName}</></FormFeedback>
                                                                ) : null}
                                                            </Col>
                                                        </Row>
                                                        <Row >
                                                            <Col lg={4} md={5} className="col-xxl-2 p-2">
                                                                <h5>Last name:</h5>
                                                            </Col>
                                                            <Col lg={4} md={5} className="col-xxl-10">
                                                                <Input
                                                                    id="lastName"
                                                                    name="lastName"
                                                                    className="form-control"
                                                                    placeholder="Enter last name"
                                                                    type="text"
                                                                    onChange={validation.handleChange}
                                                                    onBlur={validation.handleBlur}
                                                                    value={validation.values.lastName || ""}
                                                                    invalid={
                                                                        validation.touched.lastName && validation.errors.lastName ? true : false
                                                                    }
                                                                />
                                                                {validation.touched.lastName && validation.errors.lastName ? (
                                                                    <FormFeedback type="invalid"><>{validation.errors.lastName}</></FormFeedback>
                                                                ) : null}
                                                            </Col>
                                                        </Row>
                                                    </Container>
                                                    <Container fluid>
                                                        <div className="d-flex flex-row-reverse">
                                                            <div className="p-1">
                                                                <button
                                                                    className="btn btn-primary btn-block"
                                                                    type="submit"
                                                                >
                                                                    Save
                                                                </button>
                                                            </div>
                                                            <div className="p-1">
                                                                <Link
                                                                    className="btn btn-secondary btn-block"
                                                                    to={{
                                                                        pathname: "/users-managment",
                                                                        state: location.state.organisation as Organisation
                                                                    }}
                                                                >
                                                                    Cancel
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </Container>
                                                </Form>
                                            </Col>
                                        </Row>

                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    );
}

EditUsersManagment.propTypes = {
    location: PropTypes.object,
    t: PropTypes.any,
};

export default withTranslation()(withRouter(EditUsersManagment));